<div class="vbox mask-container">
  <div class="mat-h3 separator"><span class="label">Transport Info</span>{{piece.id}}</div>
  <div class="vbox">
    <div class="hbox">

      <app-display-value label="CHA" [value]="piece.cha"></app-display-value>
      <app-display-value label="Pickup Address" [value]="piece.pickupAddress"></app-display-value>
      <app-display-value label="Delivery Address" [value]="piece.deliveryAddress"></app-display-value>

      <app-display-value label="Destination" [value]="piece.flightArrival" size="small"></app-display-value>
      <app-display-value label="Flight No." [value]="piece.flightNo" size="small"></app-display-value>
      <app-display-value label="Carrier" [value]="piece.carrier"></app-display-value>
      <app-display-value label="Ground Handling Company" [value]="piece.gha"></app-display-value>
      <app-display-value label="Positioning Time" [value]="piece.positioningTime"></app-display-value>

    </div>
    <div class="mat-h3 separator"><span class="label">ULD Info</span></div>
    <div class="hbox">

      <app-display-value label="ULD" [value]="piece.uldSerial"></app-display-value>
      <app-display-value label="Handl. Instructions" [value]="piece.handlingInstructions"></app-display-value>
      <app-display-value label="Tot. Gross Weight" [value]="shipment.grossWeight"></app-display-value>
      <app-display-value label="Dimension (h×w×l)" [value]="shipment.dimension"></app-display-value>
      <app-display-value label="Volume" [value]="shipment.volume"></app-display-value>

    </div>
    <div class="mat-h3 separator"><span class="label">Piece Info</span></div>
    <div class="hbox">
      <div class="vbox">
        <app-display-value label="Master AWB" [value]="shipment.masterAwb"></app-display-value>
        <app-display-value label="House AWB" [value]="shipment.houseAwb"></app-display-value>
      </div>
      <app-pieces-table [otherPieces]="otherPieces" (select)="click($event)"></app-pieces-table>
    </div>
  </div>

</div>